import AccessControl from "./AccessControl";
import {
  useAccessControlHook,
  useGetEntitlementsData,
  useFeatureEnabled,
} from "./accessControlHook";
import { DISPLAY_MAP, FEATURE_IDS_MAP } from "./constants";
import {
  RESTRICTED_HOME_ROUTE,
  RESTRICTED_SIDEBAR_SECTIONS,
  isPathAllowedForRestrictedAccess,
  useRestrictedModuleAccess,
} from "./moduleAccess";

export const FEATURE_IDS = FEATURE_IDS_MAP;
export const useAccessControl = useAccessControlHook;
export const DISPLAY_TITLE = DISPLAY_MAP;
export const useGetEntitlements = useGetEntitlementsData;
export { useFeatureEnabled };
export {
  RESTRICTED_HOME_ROUTE,
  RESTRICTED_SIDEBAR_SECTIONS,
  isPathAllowedForRestrictedAccess,
  useRestrictedModuleAccess,
};

export default AccessControl;
